import styled from 'styled-components';
import { setColor, setRem } from '../../utils/styles';
import { motion } from 'framer-motion';

export const VideoWrapper = styled(motion.div)`
  padding: 0 ${setRem(50)} ${setRem(50)};
  max-width: ${setRem(1024)};
  margin: 0 auto;
  position: relative;
  z-index: 10;

  .video-js {
    border-radius: 20px;
    overflow: hidden;

    & .vjs-control:focus {
      outline: none;
    }
  }

  .vjs-big-play-button {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    border: 0;
    width: 3rem;
    height: 3rem;
    background-color: ${setColor.secondaryColor};
    color: ${setColor.primaryColor};
    font-size: 2rem;
  }
`;
